const productRows = [
  ['qahwa', 'Qahwa', 'Lattafa Khamrah Qahwa', 129, 'Coffee, cinnamon and warm vanilla', true],
  ['seduction', 'Seduction', 'Antonio Banderas Seduction', 99, 'Aquatic notes, spicy woods and fresh confidence', true],
  ['tuscan-leather', 'Tuscan Leather', 'Tom Ford Tuscan Leather', 99, 'Dark raspberry, rich leather and smoky woods', true],
  ['ysl-y', 'YSL Y', 'Yves Saint Laurent Y', 110, 'Bergamot, ginger, sage and cedarwood', true],
  ['born-in-roma', 'Valentino Born In Roma', 'Valentino Donna Born In Roma', 99, 'Jasmine, vanilla and modern woody notes', true],
  ['good-girl', 'Good Girl', 'Carolina Herrera Good Girl', 99, 'Jasmine, tonka bean and cocoa', true],
  ['vanilla-vibes', 'Vanilla Vibes', 'Juliette Has a Gun Vanilla Vibes', 99, 'Sea salt, vanilla and a warm summer breeze', true],
  ['stronger-with-you', 'Stronger With You', 'Emporio Armani Stronger With You', 129, 'Cardamom, chestnut and addictive vanilla', true],
  ['versace-eros', 'Versace Eros', 'Versace Eros', 110, 'Mint, green apple, tonka and vanilla', true],
  ['lattafa-khamrah', 'Lattafa Khamrah', 'Lattafa Khamrah', 110, 'Cinnamon, praline, vanilla and oud', true],
  ['ck-one', 'CK One', 'Calvin Klein CK One', 99, 'Fresh citrus, green tea and clean musk'],
  ['le-male', 'Le Male', 'Jean Paul Gaultier Le Male', 99, 'Mint, lavender and smooth vanilla', true],
  ['le-beau', 'Le Beau', 'Jean Paul Gaultier Le Beau', 99, 'Bergamot, coconut wood and tonka bean', true],
  ['afternoon-swim', 'Afternoon Swim', 'Louis Vuitton Afternoon Swim', 119, 'Sparkling citrus, aquatic accords and driftwood', true],
  ['chloe', 'Chloé', 'Chloé Eau de Parfum', 99, 'Rose, peony, lychee and warm cedar'],
  ['classic-black', 'Classic Black', 'Jaguar Classic Black', 99, 'Mandarin, orange and sandalwood', true],
  ['candy-crush', 'Candy Crush', 'Candy Crush', 119, 'Cotton candy, caramel and juicy fruits'],
  ['black-opium', 'Black Opium', 'Yves Saint Laurent Black Opium', 120, 'Coffee, sweet vanilla and warm spices', true],
  ['spice-bomb', 'Spice Bomb', 'Viktor & Rolf Spicebomb', 99, 'Cinnamon, saffron, leather and tobacco', true],
  ['creed-aventus', 'Creed Aventus', 'Creed Aventus', 99, 'Pineapple, blackcurrant, birch and vanilla', true],
  ['lady-million', 'Lady Million', 'Paco Rabanne Lady Million', 99, 'Honey, raspberry and orange blossom', true],
  ['gucci-oud', 'Gucci Oud', 'Gucci Oud', 149, 'Oud, sweet pear and warm spices', true],
  ['bright-crystal', 'Versace Bright Crystal', 'Versace Bright Crystal', 119, 'Pomegranate, peony, lotus and soft musk'],
  ['miss-dior', 'Miss Dior', 'Miss Dior', 99, 'Rose, peony and white musk'],
  ['cafe-rose', 'Café Rose', 'Tom Ford Café Rose', 99, 'Rose, coffee and sandalwood'],
  ['chanel-no-5', 'Chanel N°5', 'Chanel N°5', 99, 'Jasmine, rose and classic vanilla'],
  ['azzaro-most-wanted', 'Azzaro Most Wanted', 'Azzaro The Most Wanted', 99, 'Cardamom, caramel and amber'],
  ['dior-fahrenheit', 'Dior Fahrenheit', 'Dior Fahrenheit', 99, 'Leather, mandarin and violet'],
  ['tobacco-oud', 'Tobacco Oud', 'Tom Ford Tobacco Oud', 99, 'Oud, tobacco and aromatic spice'],
  ['rasasi-hawas', 'Rasasi Hawas', 'Rasasi Hawas', 139, 'Bergamot, cinnamon and ambergris'],
  ['shay-oud', 'Shay Oud', 'Shay Oud', 99, 'Oud, rose and amber'],
  ['ombre-nomade', 'Ombre Nomade', 'Louis Vuitton Ombre Nomade', 159, 'Oud, incense and leather'],
  ['mukhallat-oud', 'Mukhallat Oud', 'Mukhallat Oud', 149, 'Oud, musk and saffron'],
  ['vs-bombshell', 'VS Bombshell', "Victoria's Secret Bombshell", 99, 'Passionfruit, peony and vanilla'],
  ['burj-khalifa', 'Burj Khalifa', 'Burj Khalifa', 129, 'Oud, saffron and amber'],
  ['caliber', 'Caliber', 'Caliber', 99, 'Bergamot, cedar and musk'],
  ['tam-dao', 'Diptyque Tam Dao', 'Diptyque Tam Dao', 99, 'Sandalwood, cedar and soft florals'],
  ['lacoste-white', 'Lacoste White', 'Lacoste White', 99, 'Yuzu, bergamot and cedar'],
  ['dunhill-icon', 'Dunhill Icon', 'Dunhill Icon', 119, 'Black pepper, cardamom and vetiver'],
  ['gucci-flora', 'Gucci Flora', 'Gucci Flora', 99, 'Citrus, rose and patchouli'],
  ['bleu-de-chanel', 'Bleu de Chanel', 'Bleu de Chanel', 99, 'Grapefruit, aromatic woods and cedar'],
  ['armani-code', 'Armani Black Code', 'Armani Code', 99, 'Coffee, vanilla and tonka bean'],
  ['cool-water-men', 'Davidoff Cool Water Men', 'Davidoff Cool Water', 99, 'Mint, lavender and cedar'],
  ['cool-water-women', 'Davidoff Cool Water Women', 'Davidoff Cool Water Woman', 99, 'Lotus, jasmine and sandalwood'],
  ['gucci-guilty', 'Gucci Guilty', 'Gucci Guilty', 99, 'Peach, florals and patchouli'],
  ['one-million', 'One Million', 'Paco Rabanne 1 Million', 99, 'Grapefruit, cinnamon and leather'],
  ['acqua-di-gio', 'Acqua Di Giò', 'Giorgio Armani Acqua Di Giò', 99, 'Citrus, marine notes and patchouli'],
  ['dior-sauvage', 'Dior Sauvage', 'Dior Sauvage', 99, 'Bergamot, pepper and ambergris'],
  ['addiction', 'Addiction', 'Addiction', 99, 'Rose, jasmine and amber'],
  ['cr7', 'CR7', 'Cristiano Ronaldo CR7', 99, 'Citrus, lavender and cedar'],
  ['zara-black', 'Zara Black', 'Zara Black', 99, 'Black pepper, cardamom and vetiver'],
  ['musk-safi', 'Musk Safi', 'Musk Safi', 149, 'Amber, clean musk and vanilla'],
  ['ombre-leather', 'Ombre Leather', 'Tom Ford Ombre Leather', 129, 'Leather, jasmine and warm amber'],
  ['gypsy-water', 'Gypsy Water', 'Byredo Gypsy Water', 129, 'Pine, incense and sandalwood'],
  ['allure-sport', 'Allure Homme Sport', 'Chanel Allure Homme Sport', 129, 'Mandarin, aquatic notes and cedar'],
  ['oud-wood', 'Oud Wood', 'Tom Ford Oud Wood', 129, 'Oud, sandalwood and vanilla'],
  ['oud-mood', 'Oud Mood', 'Lattafa Oud Mood', 129, 'Oud, saffron and amber'],
  ['amber-oud', 'Amber Oud', 'Tom Ford Amber Oud', 129, 'Amber, oud and vanilla'],
  ['hugo-boss', 'Hugo Boss', 'Hugo Boss Bottled', 99, 'Apple, warm spice and cedar']
]

export const products = productRows.map(([id, name, inspiredBy, price, notes, isNew = false]) => ({
  id,
  name,
  inspiredBy,
  basePrice: price,
  notes,
  isNew
}))

// Every listed price is a whole rupee amount, rounded up to the nearest ₹5.
const ceilToFive = value => Math.ceil(value / 5) * 5

// Keep all commercial pricing decisions in one place.
// basePrice is the 10 ml perfume price; a 50 ml costs 4.5× that (₹100 → ₹450).
export const fragranceVariants = {
  perfume10: { id: 'perfume-10', type: 'Perfume', size: '10 ml', multiplier: 1 },
  perfume50: { id: 'perfume-50', type: 'Perfume', size: '50 ml', multiplier: 4.5 },
  ittar: { id: 'ittar', type: 'Ittar', size: '6 ml', multiplier: 1.5 }
}

export const carAromaProducts = products.map(product => ({
  ...product,
  id: `car-${product.id}`,
  basePrice: Math.max(250, ceilToFive(product.basePrice * 2.3))
}))

export const formatPrice = value => `₹${Math.round(value).toLocaleString('en-IN')}`

export const getVariantPrice = (product, variant) =>
  ceilToFive(product.basePrice * variant.multiplier)
